module.exports = __webpack_public_path__ + "img/PD_5.cd041fa9.png";